<template>
  <v-container fluid class="user-list mt-3">
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="users-table"
              show-select
              single-select
              item-key="_id"
              sort-by="userstatus"
              :footer-props="footer"
              :headers="headers"
              :items="[...salesreps.filter(user=>user.usertype=='Sales Driver')]"

              :items-per-page="itemPerPage">
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.userimage" size="50">
                  <img v-bind:src="item.userimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="50">
                  <span class="white--text headline">{{ item.username[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.usertype="{ item }">
                <p class="two-line">{{ item.usertype }}</p>
                <p v-if="item.locationid!=undefined" class="two-line">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : ''  }}</p>
              </template>
              <template v-slot:item.username="{ item }">
                <p class="two-line"><b>{{ item.username }}</b></p>
                <p class="two-line">{{ item.userid }}</p>
                <p class="two-line"><a class="primaryConst--text">{{ item.useremail }}</a></p>
                <p class="two-line">{{ item.usermobile }}</p>
              </template>
              <template v-slot:item.userstatus="{ item }">
                <v-chip
                  :color="item.userstatus=='Active' ? 'successConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.userstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item, 'Route')">
                  <v-icon>mdi-printer</v-icon>
              </v-btn>
              <v-btn icon color="primary" @click="printItem(item, 'Active')">
                  <v-icon>mdi-printer-outline</v-icon>
              </v-btn>
              <v-btn icon color="primary" @click="printItem(item, 'Map')">
                  <v-icon>mdi-map</v-icon>
              </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UserList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteuser: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Name', value: 'username' },
        { text: 'Type', value: 'usertype' },
        { text: 'Status', value: 'userstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      switch1: true,
      }
  },
  computed: {
    ...mapState('Location', ['locations']),
    ...mapState('SalesRep', ['salesreps', 'isReceiving', 'isDeleting', 'idToDelete', 'salesrepsMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SalesRep', ["getSalesRepsRequest"]),
    editItem(item) {
      console.log(item)
      this.$router.push({ name: 'SalesRepEdit', params: item })
    },
    printItem(item, route) {
      if(route=='Active') this.$router.push({ name: 'SalesRepActivePrint', params: item });
      else if(route=='Route') this.$router.push({ name: 'SalesRepRoutePrint', params: item });
      else if(route=='Map') this.$router.push({ name: 'SalesRepMapPrint', params: item });
      else this.$router.push({ name: 'SalesRepPrint', params: item });
    },
    deleteItem(item) {
      this.deleteUserRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      console.log(item);
      this.dialog = true;
      this.deleteuser = {
        _id: item._id,
        username: item.username,
      }
    },
  },
  async created () {
    if(this.salesreps.length==0) await this.getSalesRepsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    console.log(this.salesreps)
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
